import React, { useEffect, useState } from 'react';
import AutoCompleteResource from '../../reusable-components/autoComplete/autoCompleteResource';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import AddIcon from '@material-ui/icons/Add';
import PeopleOutlineOutlinedIcon from '@material-ui/icons/PeopleOutlineOutlined';
import WorkOutlineOutlinedIcon from '@material-ui/icons/WorkOutlineOutlined';
import RemoveIcon from '@material-ui/icons/Remove';
import MenuItem from '../../reusable-components/ItemHoverBased';
import fire from '../../../config/firebase';
import { withRouter } from 'react-router-dom';
import AlertDialog from '../AlertDialog/AlertDialog';
import PhaseCalculation from '../Phase/phaseCalculationUtil';
import ResourceEdit from './ResourceEdit';

function Resource({
    resource = {},
    addResource,
    updateResource: updateResourceFn,
    deleteResource,
    duplicateResource,
    editResources,
    classes,
    estimate = {},
    toggleEditDrawer,
    editVendorValue
}) {
    //    console.log('edit', toggleEditDrawer);
    const [focusField, setFocusField] = useState(null);
    const [updateCnt, setUpdateCnt] = useState(0);
    // const [updateData, setUpdateData] = useState({});
    const updateResource = (updatedData, resource, fieldId) => {
        if (fieldId) {
            setFocusField(fieldId);
        }
        return updateResourceFn(updatedData, resource);
    }
    const phaseCalculationCls = new PhaseCalculation(
        {},
        {},
        estimate
    );

    const amount = phaseCalculationCls.resourceCalculate(resource, 'amount', false);
    const cost = phaseCalculationCls.resourceCalculate(resource, 'cost', false);
    const { resourceName, hours, type } = resource;
    const [show, showFun] = React.useState(false);
    const [cnt, setCnt] = React.useState(0);
    const [qty, qtyFun] = React.useState(1);
    const [resourcesRole, setResourcesRole] = React.useState([]);
    const [resourcesVendor, setVendorResources] = React.useState([]);
    const [dialogOpen, setdialogOpen] = useState(false);

    const initAsync = async (resource) => {
        qtyFun(resource ? resource.qty : 1);
        const ref = fire.database().ref('resources');
        const snapshot = await ref.once('value');
        const resources = snapshot.val();
        ref.off('value');
        const resourceList = [];
        const role = "Role";
        const vendor = "Vendor";
        for (const id in resources) {
            resources[id].icon = resources[id].type === 'Role' ? PeopleOutlineOutlinedIcon : WorkOutlineOutlinedIcon;
            resourceList.push({ id, ...resources[id] });
        }
        const roleList = resourceList.filter(function (resource) {
            return resource.subtitle?.toLowerCase().match(role.toLowerCase());
        });
        const vendorList = resourceList.filter(function (resource) {
            return resource.subtitle?.toLowerCase().match(vendor.toLowerCase());
        });
        setResourcesRole(roleList);
        setVendorResources(vendorList);
    }
    useEffect(() => {
        initAsync(resource);
    }, [resource]);

    const itemShow = () => {
        setCnt(cnt + 1)
        showFun(true);
    }
    const qtyIncrease = () => {
        qtyFun(Math.max(qty + 1, 100));
        updateResource({ ...resource, qty: qty + 1 });
    }
    const qtyDecrease = () => {
        if (qty === 1) { return false; }
        qtyFun(qty - 1);
        updateResource({ ...resource, qty: qty - 1 });
    }

    const qtydelete = () => {
        deleteResource(resource);
        setdialogOpen(false);
    }
    const closeHandler = () => {
        setdialogOpen(false);
    }
    const updateResourceLocal = (data, resource) => {
        updateResource(data, resource);
    }

    return (
        <div style={{ marginBottom: '0' }} className="one-line-elment">

            <div className="list">
                {type === 'Role' ? <PeopleOutlineOutlinedIcon className="resource_icon"
                    htmlColor="#2ab7ca"
                /> : <WorkOutlineOutlinedIcon htmlColor="#2ab7ca" className="resource_icon"
                />}
                <AutoCompleteResource
                    key={resource.resourceId + resourceName + cnt}
                    classes={classes.addTask}
                    update={(updateData) => updateResource(updateData, resource)}
                    insert={(newResource) => {
                        addResource(newResource, resource);
                    }}
                    resourceName={resource.resourceName || ""}
                    title={resource.type + ' Name'}
                    show={() => { itemShow(); }}
                    dataList={type === 'Role' ? resourcesRole : resourcesVendor}
                    type={type}
                />

            </div>

            <MenuItem
                deleteHandle={() => { setdialogOpen(true) }}
                duplicateResource={() => {
                    duplicateResource(resource);
                }
                }
                data={resource}
                hours={hours}
                editResources={() => editResources(resource)}
                toggleEditDrawer={() => toggleEditDrawer(resource, updateResourceLocal)}
                editVendorValue={editVendorValue}
            />
            {(show || resourceName) && (
                <React.Fragment>
                    <div className='resource-wrap'>
                        <div className="list drop-box qty gray-circle" >
                            <input type="number" min="1" value={qty} readOnly={true} />
                            {qty < 2 ?
                                <DeleteOutlinedIcon
                                    htmlColor="#000000"
                                    fontSize="small"
                                    className="delete"
                                    onClick={() => { setdialogOpen(true) }}
                                />
                                :
                                <RemoveIcon
                                    htmlColor="#000000"
                                    fontSize="small"
                                    className="delete"
                                    onClick={qtyDecrease}
                                />
                            }

                            <AddIcon
                                htmlColor="#000000"
                                fontSize="small"
                                className="add"
                                onClick={qtyIncrease}
                            />
                        </div>
                        <div className="list hrs" >
                            <ResourceEdit
                                fieldKey={resource.resourceId + 'hours' + cost}
                                resource={resource}
                                updateResource={updateResource}
                                editable={true}
                                max={10000}
                                field='hours'
                                prefix=""
                                isFocused={focusField === resource.resourceId + 'hours'}
                                key={updateCnt + resource.resourceId + 'hours' + cost}
                            />
                        </div>
                        <div className="list cost" >
                            <ResourceEdit
                                //editable={resource.type === 'Vendor'}
                                resource={resource}
                                updateResource={updateResource}
                                value={cost}
                                max={100000}
                                refresh={() => { setUpdateCnt(updateCnt + 1) }}
                                field='cost'
                                fieldKey={resource.resourceId + 'cost' + cost}
                                isFocused={focusField === resource.resourceId + 'cost'}
                            />
                        </div>
                        <ResourceEdit
                            editable={false}
                            resource={resource}
                            updateResource={updateResource}
                            value={amount}
                            field='amount'
                        />
                    </div>
                </React.Fragment>
            )}
            <AlertDialog
                open={dialogOpen}
                onClose={closeHandler}
                keyValue={qtydelete}
                name={"resource"}
            />

        </div>

    )
}
export default withRouter(Resource);